module.exports = __webpack_public_path__ + "media/images/common/menu_btn1-fdbcfa49a05ad76d41baa63049c8dd9c.png";